import { IGoogleMapsAddressResponse } from '@interfaces/IBSRequest';

export const getFormattedAddressFromGoogleResponse = (
  response: IGoogleMapsAddressResponse
): string => {
  if (response.results.length) {
    const firstResult = response.results[0];
    if (firstResult?.formatted_address && firstResult?.formatted_address !== '') {
      return firstResult?.formatted_address;
    }
    return '';
  }
  return '';
};
